module.exports = __webpack_public_path__ + "img/es_mi_videostill2.ae0a25b8.jpg";